import { gql } from '@apollo/client';

const UPDATE_STUDY_SECONDARY_CONTACT = gql`
  mutation updateStudySecondaryContact($input: UpdateStudySecondaryContactInput!) {
    updateStudySecondaryContact(input: $input) {
      isSuccess
      message
    }
  }
`;

export default UPDATE_STUDY_SECONDARY_CONTACT;
